import React from "react";

const About = () => {
    return (
        <div className="mt-10 p-8 text-center mx-auto max-w-screen-md">
            <h1 className="text-4xl font-bold mb-5 text-center">About Us</h1>
            <div className="">
                <div className="mb-5 font-semibold">
                    Welcome to CoderHeaven, where technology meets{" "}
                    <span className="text-red-500 font-bold">innovation</span>,
                    and web development enthusiasts find their perfect
                    accessories. Our journey began with a{" "}
                    <span className="text-red-500 font-bold">passion</span> for
                    creating a platform that caters specifically to web
                    developers, offering a curated selection of high-quality
                    products tailored to your needs.
                </div>
                <div className="mb-5 font-semibold">
                    At CoderHeaven, we understand that the right tools can make
                    all the difference in your coding journey. That's why we've
                    made it our mission to source the finest accessories, from
                    cutting-edge headphones and ergonomic keyboards to
                    top-of-the-line monitors, precision mice, and reliable
                    webcams. We believe that when you have the best gear at your
                    fingertips, you can push the boundaries of your{" "}
                    <span className="text-red-500 font-bold">creativity</span>{" "}
                    and{" "}
                    <span className="text-red-500 font-bold">productivity</span>
                    .
                </div>
                <div className="mb-5 font-semibold">
                    Our team is comprised of tech enthusiasts who share your{" "}
                    <span className="text-red-500 font-bold">passion</span> for
                    web development. We're dedicated to providing you with a{" "}
                    <span className="text-red-500 font-bold">seamless</span>{" "}
                    shopping experience,{" "}
                    <span className="text-red-500 font-bold">insightful</span>{" "}
                    product recommendations, and{" "}
                    <span className="text-red-500 font-bold">exceptional</span>{" "}
                    customer support. Your satisfaction is our priority, and
                    we're always here to assist you on your quest for the
                    perfect tech companion.
                </div>
                <div className="mb-5 font-semibold">
                    Whether you're a seasoned developer looking to upgrade your
                    workspace or a novice seeking your first set of tools,
                    CoderHeaven is here to{" "}
                    <span className="text-red-500 font-bold">empower</span> you.
                    Join us on this exciting journey, and together, we'll{" "}
                    <span className="text-red-500 font-bold">elevate</span> the
                    way you work and code. Thank you for choosing us as your
                    partner in web development excellence!
                </div>
            </div>
        </div>
    );
};

export default About;
